import Statistic from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default Statistic;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/statistic/index.js
// module id = 833
// module chunks = 3